// extracted by mini-css-extract-plugin
export default {"applyButton":"CheckButton_applyButton__m-CsZ","check":"CheckButton_check__iLeRp","valid":"CheckButton_valid__WOdM3","error":"CheckButton_error__3CSWK"};